import { Navigate } from 'react-router-dom';
import { NotFound } from '../../common/SharedComponents';
import store from '@apply/adminStore';

const BasePathRouting: React.FC = () => {
    const { bfiUser } = store.getState();

    if (!bfiUser.authenticated) {
        return <Navigate to='/login' />;
    }

    if (bfiUser.isBroker && !bfiUser.areTermsAccepted) {
        return <Navigate to='/brokeraccount' />;
    }

    if (bfiUser.isBroker && bfiUser.areTermsAccepted && bfiUser.requiresESign) {
        return <Navigate to='/broker/signagreement' />;
    }

    if (bfiUser.admin && (bfiUser.requiresESign || bfiUser.requiresAdminTermsESign)) {
        return <Navigate to='/admin/signagreement' />;
    }

    if (bfiUser.admin) {
        return <Navigate to='/loans/outstanding' />;
    }

    if (bfiUser.isBroker) {
        return <Navigate to='/referrals' />;
    }

    return <NotFound />;
};

export default BasePathRouting;
